import { Nullable } from "@/general/custom-types/CustomTypes";

export class ModelFilter {
  name?: Nullable<string>;

  constructor(name?: Nullable<string>) {
    this.name = name;
  }

  toQueryParam(): string {
    let query: string = "";
    if (this.name && this.name !== "") {
      query += `&search=${this.name}`;
    }
    return query;
  }
}
